// import {useState} from "react";
// import {MembershipsInTour, TourMembership} from "../models/membership";
// import {deleteTour, getAccountsInTour} from "../api/tourApi";
// import {UserRole} from "../models/account";
// import {deleteTourMembership} from "../api/membershipTourApi";
//
// export function useTourDeletion(
//     membership: TourMembership,
//     onReloadMemberships: () => void
// ) {
//     const [openDeleteTourConfirmDialog, setOpenDeleteTourConfirmDialog] = useState(false);
//     const [openLeaveConfirmDialog, setOpenLeaveConfirmDialog] = useState(false);
//     const [openDeleteOptionForAdmin, setOpenDeleteOptionForAdmin] = useState(false);
//
//     const [otherAdmins, setOtherAdmins] = useState(false);
//     const [membershipsInTour, setMembershipsInTour] = useState<MembershipsInTour | null>(null);
//
//     async function loadMemberships(): Promise<MembershipsInTour | null> {
//         try {
//             const data = await getAccountsInTour(membership.tour.id);
//             setMembershipsInTour(data);
//             return data;
//         } catch {
//             return null;
//         }
//     }
//
//     async function handleDelete() {
//         if (membership.role === UserRole.MEMBER || membership.role === UserRole.APPLIED) {
//             setOpenLeaveConfirmDialog(true);
//             return;
//         }
//
//         const data = await loadMemberships();
//
//         if (data) {
//             const hasOtherAdmins = areOtherAdminsOrCreatorsInTour(
//                 data,
//                 membership.account.id
//             );
//             setOtherAdmins(hasOtherAdmins);
//         } else {
//             setOtherAdmins(false);
//         }
//
//         setOpenDeleteOptionForAdmin(true);
//     }
//
//     async function handleLeaveTour() {
//         await deleteTourMembership(membership.account.id, membership.tour.id);
//         await onReloadMemberships();
//     }
//
//     async function handleDeleteTour() {
//         await deleteTour(membership.tour.id);
//         await onReloadMemberships();
//     }
//
//     return {
//         openDeleteTourConfirmDialog,
//         openLeaveConfirmDialog,
//         openDeleteOptionForAdmin,
//         otherAdmins,
//         membershipsInTour,
//
//         setOpenDeleteTourConfirmDialog,
//         setOpenLeaveConfirmDialog,
//         setOpenDeleteOptionForAdmin,
//
//         handleDelete,
//         handleDeleteTour,
//         handleLeaveTour,
//         loadMemberships
//     };
// }
//
// export function areOtherAdminsOrCreatorsInTour(
//     membershipsInTour: MembershipsInTour,
//     myAccountId: number
// ): boolean {
//     return membershipsInTour.memberships.some(m =>
//         m.accountId !== myAccountId &&
//         (m.userRole === UserRole.ADMIN || m.userRole === UserRole.CREATOR)
//     );
// }

import {useState} from "react";
import {MembershipsInTour, TourMembership} from "../models/membership";
import {deleteTour, getAccountsInTour} from "../api/tourApi";
import {UserRole} from "../models/account";
import {deleteTourMembership} from "../api/membershipTourApi";
import {useDbUpdates} from "../hooks/useDbUpdates";

export function useTourDeletion(
    membership: TourMembership,
    onReloadMemberships: () => void
) {
    const [openDeleteTourConfirmDialog, setOpenDeleteTourConfirmDialog] = useState(false);
    const [openLeaveConfirmDialog, setOpenLeaveConfirmDialog] = useState(false);
    const [openDeleteOptionForAdmin, setOpenDeleteOptionForAdmin] = useState(false);

    const [otherAdmins, setOtherAdmins] = useState(false);
    const [membershipsInTour, setMembershipsInTour] = useState<MembershipsInTour | null>(null);

    async function loadMemberships(): Promise<MembershipsInTour | null> {
        try {
            const data = await getAccountsInTour(membership.tour.id);
            setMembershipsInTour(data);
            return data;
        } catch {
            return null;
        }
    }

    // 🔥 Automatischer Reload bei DB-Änderungen
    useDbUpdates(true, loadMemberships);

    async function handleDelete() {
        if (membership.role === UserRole.MEMBER || membership.role === UserRole.APPLIED) {
            setOpenLeaveConfirmDialog(true);
            return;
        }

        const data = await loadMemberships();

        if (data) {
            const hasOtherAdmins = areOtherAdminsOrCreatorsInTour(
                data,
                membership.account.id
            );
            setOtherAdmins(hasOtherAdmins);
        } else {
            setOtherAdmins(false);
        }

        setOpenDeleteOptionForAdmin(true);
    }

    async function handleLeaveTour() {
        await deleteTourMembership(membership.account.id, membership.tour.id);
        await onReloadMemberships();
    }

    async function handleDeleteTour() {
        await deleteTour(membership.tour.id);
        await onReloadMemberships();
    }

    return {
        openDeleteTourConfirmDialog,
        openLeaveConfirmDialog,
        openDeleteOptionForAdmin,
        otherAdmins,
        membershipsInTour,

        setOpenDeleteTourConfirmDialog,
        setOpenLeaveConfirmDialog,
        setOpenDeleteOptionForAdmin,

        handleDelete,
        handleDeleteTour,
        handleLeaveTour,
        loadMemberships
    };
}

export function areOtherAdminsOrCreatorsInTour(
    membershipsInTour: MembershipsInTour,
    myAccountId: number
): boolean {
    return membershipsInTour.memberships.some(m =>
        m.accountId !== myAccountId &&
        (m.userRole === UserRole.ADMIN || m.userRole === UserRole.CREATOR)
    );
}